<template>
  <div class="popup-modal">
    <div class="popup-modal-wrapper">
      <div class="popup-modal-dialog">
        <div class="popup-modal-content">
          <div class="popup-modal-body">
            <slot name="body" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ScoutPopupModal',
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.popup-modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $z-index-popup;
  outline: 0;
}

.popup-modal-wrapper {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
}

.popup-modal-dialog {
  position: relative;
  margin: auto 12px;
  width: 100%;

  @media screen and (max-width: 768px) {
    margin: auto 0;
  }
}

.popup-modal-content {
  width: 500px;
  margin: 0 auto;
  border-radius: 10px;
  position: relative;
  background-color: $oc-white;
  background-clip: padding-box;
  outline: 0;

  @media screen and (max-width: 768px) {
    width: calc(100% - 24px);
  }
}

.popup-modal-body {
  position: relative;
  padding: 32px 0 16px;
}
</style>
